import { ChangeEvent, useEffect, FC } from 'react';
import {
  UiCheckbox,
  UiIcon,
  UiInput,
  UiPhoneInput,
  UiText,
} from '@frontend/znanie-uikit';

import { UploadFiles } from 'components/common/UploadFiles';

import { useMediaQueries } from 'hooks/utils/useMediaQueries';

import * as T from './ThirdStepForm.types';

import css from '../../Form.module.scss';

export const ThirdStepForm: FC<T.IThirdStepForm> = ({ formik, user }) => {
  const { isTabletOrDesktop } = useMediaQueries();

  const {
    values,
    setValues,
    touched,
    errors,
    handleChange,
    handleBlur,
    setFieldValue,
    setTouched,
  } = formik;

  useEffect(() => queueMicrotask(() => setTouched({})), []);

  const { socials, phone, email, isConsent, isEnrolledToLeagueOfLecturers } =
    values;

  const handleChangeLinks = (
    event: ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    let newValue = [...socials];

    newValue[index] = {
      ...socials[index],
      link: event.target.value,
    };

    setValues({
      ...values,
      socials: newValue,
    });
  };

  return (
    <>
      <UiPhoneInput
        inputProps={{
          value: phone,
          id: 'phone',
          name: 'phone',
          tabIndex: 1,
          autoFocus: true,
          fluid: true,
          label: 'Телефон*',
          disabled: !!user?.phone,
          errorLabel: touched.phone && errors.phone ? errors.phone : undefined,
          inputSize: isTabletOrDesktop ? 'normal' : 'small',
          onChange: handleChange,
          onBlur: handleBlur,
        }}
      />

      <UiInput
        id="email"
        name="email"
        tabIndex={2}
        fluid
        label="Email*"
        maxLength={70}
        placeholder="Укажите ваш email"
        disabled={!!user?.email}
        value={email}
        onChange={handleChange}
        errorLabel={touched.email || errors.email ? errors.email : undefined}
        inputSize={isTabletOrDesktop ? 'normal' : 'small'}
      />

      {socials.map((item: any, index: number) => {
        return (
          <div key={item.name} className={css.socials}>
            <div className={css.input}>
              <UiInput
                id={`field_${item.name}`}
                name={`field_${item.name}`}
                tabIndex={index + 1 + 2}
                fluid
                label={item.label}
                errorLabel={
                  touched[`field_${item.name}`] && errors.socials?.[item.name]
                    ? (errors.socials[item.name] as string)
                    : undefined
                }
                placeholder="Вставьте ссылку"
                onChange={(e: ChangeEvent<HTMLInputElement>) =>
                  handleChangeLinks(e, index)
                }
                onBlur={handleBlur}
                value={socials[index].link}
                inputSize={isTabletOrDesktop ? 'normal' : 'small'}
              />
            </div>
          </div>
        );
      })}

      <div className={css.officialPhotoFile}>
        <UploadFiles
          tabIndex={7}
          defaultFiles={values.officialPhoto}
          label="Прикрепить личное фото"
          allowExtensions={['.png', '.jpg', '.jpeg']}
          note={'только форматы .png, .jpg, .jpeg'}
          onUpload={(files) => setFieldValue('officialPhoto', files)}
        />
        <div className={css.officialPhotoText}>
          <UiIcon name="mark-info" size={19} color="#426fff" />
          <UiText color="grey" size="small_x">
            Официальный, деловой стиль
          </UiText>
        </div>
      </div>

      <UiCheckbox
        tabIndex={socials.length + 2}
        checked={isConsent}
        label="Даю согласие на обработку моих персональных данных"
        onChange={(e) => setFieldValue('isConsent', e.target.checked)}
      />

      <UiCheckbox
        checked={isEnrolledToLeagueOfLecturers}
        label={
          <UiText size="small" color="grey" className={css.text}>
            Хочу принять участие в 3-ем сезоне{' '}
            <UiText
              href="/ligalektorov"
              target="_blank"
              size="small"
              color="blue"
              className={css.text}
            >
              Лиги Лекторов
            </UiText>
          </UiText>
        }
        onChange={(e) =>
          setFieldValue('isEnrolledToLeagueOfLecturers', e.target.checked)
        }
        disabled
      />

      {user?.leagueLecturersEnrollment && (
        <UiText size="small" color="grey">
          Вы уже подавали заявку на участие в Лиге Лекторов
        </UiText>
      )}
    </>
  );
};
